@if (shippingInstructions.data$|async; as si) {
  @if ($safeNavigationMigration(si?.over_under_delivery?.over_delivery) !== null && si.over_under_delivery.over_delivery.length > 0) {
    <div class="whitebox">
      <h3>Lieferbedingungen</h3>
      <delivery-condition-ou-table tableName="Überlieferung"
        [deliveryConditionList]="si.over_under_delivery.over_delivery">
      </delivery-condition-ou-table>
    </div>
  }
} @else {
  <ng-template [ngTemplateOutlet]="loadingOrError.template"></ng-template>
}
<loading-or-error
  #loadingOrError
  [loadingWrapper]="shippingInstructions"
  [errorMessage]="'Konnte Lieferbedingungen nicht laden'"
  [spinnerSize]="2"
  spinnerName="circle-o-notch">
</loading-or-error>
